import React, { useMemo } from 'react';

import { useBetslipState } from '@atlas/core';
import { marketTypeParser } from '@atlas/display-layouts';

import { OUTRIGHTS_DEFAULT_VIEW } from 'common/constants';
import ErrorBoundary from 'common/ErrorBoundary';
import useTranslate from 'common/I18n/Interpreter';
import eventShape from 'common/PropTypes/eventShape';
import marketTypeShape from 'common/PropTypes/marketTypeShape';

import MarketTypeDefaultView from './MarketTypeDefaultView';
import MarketTypeOutrightView from './MarketTypeOutrightView';

const DetailsMarketType = props => {
  const { event = {}, marketType } = props;
  const { outright: isOutright } = event;
  const t = useTranslate();

  const {
    settings: { feeds },
  } = useBetslipState();

  const data = useMemo(() => {
    try {
      return marketTypeParser({
        event,
        feeds,
        marketType,
        t,
      });
    } catch (e) {
      console.error('MarketTypeDefaultView e', e, marketType);

      if (window.DD_RUM) {
        window.DD_RUM.addError(
          { ...e, message: 'marketType template error' },
          {
            eventId: event?.id,
            marketTypeId: marketType?.id,
          },
        );
      }
      return null;
    }
  }, [event, feeds, marketType, t]);

  if (!data) {
    return null;
  }

  if (isOutright && !OUTRIGHTS_DEFAULT_VIEW.includes(marketType.id)) {
    return <MarketTypeOutrightView {...props} data={data} />;
  }

  // we can set adapter here
  return (
    <ErrorBoundary>
      <MarketTypeDefaultView {...props} data={data} />
    </ErrorBoundary>
  );
};

DetailsMarketType.propTypes = {
  event: eventShape.isRequired,
  marketType: marketTypeShape.isRequired,
};

export default DetailsMarketType;
